const styles = (theme) => ({
    container: {
        position: 'relative',
    },
    containerHeader: {
        backgroundColor: '#fff',
    },
    logo: {
        margin: '0 1em',
        height: '2.8em',
        '& > img': {
            height: '100%',
        },
        flex: 1,
        display: 'flex',
        alignItems: 'center',
    },
    spanPortalName: {
        fontSize: '1.5em',
        fontWeight: '500',
    },
    color1: {
        margin: '0px 0px 0px 10px',
        color: theme.palette.primary.main,
    },
    color2: {
        color: theme.palette.primary.light,
    },
    color3: {
        margin: '0px 10px 0px 0px',
        color: theme.palette.primary.main,
    },
    orgName: {
        borderRight: '1px solid lightgray',
        fontSize: '0.67em',
        width: '10px',
        height: '30px',
    },
    title: {
        borderRight: '1px solid lightgray',
        paddingRight: '1em',
        marginLeft: '1em',
        textTransform: 'uppercase',
    },
    profile: {
        flex: '0 0 auto',
        display: 'flex',
        alignItems: 'center',
    },
    user: {
        paddingRight: '1em',
        textAlign: 'right',
        borderRight: '1px solid lightgray',
        cursor: 'pointer',
    },
    name: {
        fontSize: '.9em',
        textTransform: 'uppercase',
        fontWeight: 500,
    },
    email: {
        color: 'royalblue',
        fontSize: '.8em',
        margin: 0,
    },
    logOutButton: {},
    crc: {
        width: '150px',
        margin: '5px 10px 5px 0',
        border: '1px solid #efefef',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        textTransform: 'uppercase',
        color: '#666',
        '& h3': {
            margin: '0',
            fontSize: '1em',
        },
        '& h4': {
            margin: '0',
            fontSize: '.6em',
        },
        cursor: 'pointer',
    },
    iconCrc: {
        borderRadius: '50%',
        width: '30px',
        height: '30px',
        // backgroundColor: "#D5DCE8",
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: '#23659E',
        margin: '0 10px',
        cursor: 'pointer',
        fontSize: '1em',
    },
    icon: {
        width: '.6em',
        height: '.6em',
    },
});

export default styles;
